const escapeRegex = (str: string) => str.replace(/[/\\]/g, "\\$&");

const highlightQueryWords = (text: string | undefined, queryWords: string[]) => {
    if (!text) {
        return "";
    }

    const seenWords = new Set<string>();
    const escapedQueryWords = queryWords.map((word) => escapeRegex(word));
    const pattern = `(?<![\\p{L}])(${escapedQueryWords.join("|")})`;

    let regex;
    try {
        regex = new RegExp(pattern, "gui");
    } catch {
        return text;
    }

    return text.split(regex).map((part, index) => {
        const lowerPart = part.toLowerCase();
        if (queryWords.includes(lowerPart) && !seenWords.has(lowerPart)) {
            seenWords.add(lowerPart);
            return <strong key={index}>{part}</strong>;
        }
        return part;
    });
};

export default highlightQueryWords;
